import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button } from '@folio/stripes/components';
var IMPORT_PATH = '/czna-authorities/import';
/**
 * Standalone navigation button for Imports, placed at the bottom of the nav pane.
 */
var ImportNavButton = function () {
    var history = useHistory();
    var pathname = useLocation().pathname;
    var intl = useIntl();
    var isActive = pathname === IMPORT_PATH || pathname.startsWith("".concat(IMPORT_PATH, "/"));
    var handleClick = useCallback(function () {
        if (pathname !== IMPORT_PATH)
            history.push(IMPORT_PATH);
    }, [history, pathname]);
    return (React.createElement(Button, { onClick: handleClick, buttonStyle: isActive ? 'primary' : 'default', fullWidth: true, marginBottom0: true, style: { justifyContent: 'flex-start' }, "aria-current": isActive ? 'page' : undefined },
        React.createElement("span", { style: { marginLeft: '0.5rem' } }, intl.formatMessage({ id: 'ui-czna-authorities.navigation.imports' }))));
};
export default ImportNavButton;
